import { routeCreator } from "../../../helpers/routing/routeCreator";
import Edit from "../pages/create";
import Create from "../pages/create";
import Index from "../pages/index";
import NewRegistration from "../pages/newRegistration";
import MobileIndex from "../pages/mobileIndex";






export const ROUTE_PAGE_REGISTRATIONS_INDEX = routeCreator(Index, '/registrations', 'Registrations', 'page.registrations', {exact: true})
export const ROUTE_PAGE_REGISTRATION_CREATE = routeCreator(Create, '/registration/create', 'Create', 'page.create', { exact: true })
export const ROUTE_PAGE_NEW_REGISTRATION = routeCreator(NewRegistration, '/new-registration', 'New Registration', 'page.newRegistration', { exact: true })
export const ROUTE_PAGE_NEW_REGISTRATION_EDIT = routeCreator(NewRegistration, '/new-registration/edit/:registrationId', 'Edit', 'page.edit.mobile')
export const ROUTE_PAGE_MOBILE_REGISTRATIONS_INDEX = routeCreator(MobileIndex, '/mobile/index', 'Registration', 'page.mobileRegistration', { exact: true })
export const ROUTE_PAGE_REGISTRATION_EDIT = routeCreator(Edit, '/registration/edit/:registrationId', 'Edit', 'page.edit')

const router = {
    ROUTE_PAGE_MOBILE_REGISTRATIONS_INDEX,
    ROUTE_PAGE_NEW_REGISTRATION_EDIT,
    ROUTE_PAGE_NEW_REGISTRATION,
    ROUTE_PAGE_REGISTRATIONS_INDEX,
    ROUTE_PAGE_REGISTRATION_CREATE,
    ROUTE_PAGE_REGISTRATION_EDIT
}

export default router